export interface Pot {
  id: string;
  userId?: string;
  name: string;
  description?: string | null;
  currency: 'BRL' | 'GBP' | 'USD' | 'EUR';
  balance: number;
  totalExpenses?: number;
  totalIncome?: number;
  budget?: number | null;
  budgetRemaining?: number | null;
  color: string;
  icon?: string | null;
  isDefault: boolean;
  transactionCount: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PotsListResponse {
  pots: Pot[];
  total: number;
  totalBalance: Record<string, number>;
}

export interface CreatePotInput {
  name: string;
  description?: string;
  currency: 'BRL' | 'GBP' | 'USD' | 'EUR';
  color?: string;
  icon?: string;
}

export interface UpdatePotInput {
  name?: string;
  description?: string;
  color?: string;
  icon?: string;
}

export const POT_COLORS = [
  '#EF4444', // red
  '#F97316', // orange
  '#EAB308', // yellow
  '#22C55E', // green
  '#06B6D4', // cyan
  '#3B82F6', // blue
  '#8B5CF6', // violet
  '#EC4899', // pink
  '#6B7280', // gray
  '#10B981', // emerald
] as const;

export const CURRENCY_SYMBOLS: Record<string, string> = {
  BRL: 'R$',
  GBP: '£',
  USD: '$',
  EUR: '€',
};

export const CURRENCY_NAMES: Record<string, string> = {
  BRL: 'Real Brasileiro',
  GBP: 'Libra Esterlina',
  USD: 'Dólar Americano',
  EUR: 'Euro',
};
